import { useTranslation } from "react-i18next";
import { useEffect } from "react";

interface LanguageSwitcherProps {
  compact?: boolean;
  light?: boolean;
}

const LanguageSwitcher = ({ compact = false, light = false }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar";

  useEffect(() => {
    const dir = isAr ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", isAr ? "ar" : "en");
    if (isAr) {
      document.body.style.fontFamily = "'Noto Sans Arabic', 'Segoe UI', sans-serif";
    } else {
      document.body.style.fontFamily = "";
    }
  }, [isAr]);

  const toggle = () => {
    i18n.changeLanguage(isAr ? "en" : "ar");
  };

  if (compact) {
    return (
      <button
        onClick={toggle}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border transition-all cursor-pointer whitespace-nowrap ${
          light
            ? "border-white/40 text-white hover:bg-white/20"
            : "border-amber-200 text-amber-700 hover:bg-amber-50 bg-white"
        }`}
      >
        <i className="ri-translate-2 text-sm"></i>
        {isAr ? "EN" : "عربي"}
      </button>
    );
  }

  return (
    <div className="flex items-center bg-amber-50 border border-amber-200 rounded-full p-0.5 gap-0.5">
      <button
        onClick={() => i18n.changeLanguage("en")}
        className={`px-3 py-1.5 rounded-full text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
          !isAr ? "bg-amber-500 text-white" : "text-amber-600 hover:text-amber-700"
        }`}
      >
        EN
      </button>
      <button
        onClick={() => i18n.changeLanguage("ar")}
        className={`px-3 py-1.5 rounded-full text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${
          isAr ? "bg-amber-500 text-white" : "text-amber-600 hover:text-amber-700"
        }`}
      >
        عربي
      </button>
    </div>
  );
};

export default LanguageSwitcher;
